/** @jsx isolateComponent */
import { labelStyles, withModifier } from '@zapier/common-utils';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon, IconName } from '@zapier/zinnia-icons';
import { Colors } from '@zapier/design-system';

type HelpCenterLinkIconProps = {
  /**
   * Is the icon is being hovered over.
   */
  isActive?: boolean;
  /**
   * The name of an icon that exists within the Design System.
   */
  name: IconName;
  /**
   * The width and height of the icon wrapper in pixels.
   */
  size: 30 | 40;
};

const HelpCenterLinkIconStyles = labelStyles(__filename, {
  root: (props: HelpCenterLinkIconProps) => [
    {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: Colors.PrimeWhite,
      border: `1px solid ${Colors.GrayWarm3}`,
    },
    withModifier(`${props.size}`, {
      borderRadius: Math.ceil(0.25 * props.size),
      height: props.size,
      width: props.size,
    }),
  ],
});

/**
 * This was partially copied from design-system-microlibrary
 * Renders an icon with some styling around it. Rebrand only.
 */
const HelpCenterLinkIcon = (props: HelpCenterLinkIconProps) => {
  const { size } = props;
  const iconSize = Math.ceil(0.6 * size);

  return (
    <span css={HelpCenterLinkIconStyles.root(props)}>
      <Icon name={props.name} size={iconSize} />
    </span>
  );
};

export default HelpCenterLinkIcon;
